// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.c05-expanding-box",
        "codeId": "c05",
        "events": [
            {
                "eventTarget": ".expanding-box-trigger[aria-expanded=true]",
                "eventType": "click",
                "eventName": "C05_ExpandingBoxNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "expanding box",
                    "componentId": "c05",
                    "eventType": "expanding box expansion click",
                    "elementType": "expanding box",
                    "elementText": "",
                    "titleText": "",
                    "parentName": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".expanding-box-trigger[aria-expanded=false]",
                "eventType": "click",
                "eventName": "C05_ExpandingBoxNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "expanding box",
                    "componentId": "c05",
                    "eventType": "expanding box collapse click",
                    "elementType": "expanding box",
                    "elementText": "",
                    "titleText": "",
                    "parentName": "",
                    "parentTitle": ""
                }
            },
            // Hopefully this only targets PSE searches...
            {
                "eventTarget": "#searchText + .form-group-btn .eqsearch",
                "eventType": "click",
                "tags": {
                    "componentId": "pse",
                    "componentName": "search equipment",
                    "elementType": "search box",
                    "elementText": "",
                    "event": "onsite search",
                    "eventType": "manufacturer search submit",
                    "searchTerm": "",
                    "searchType": "emebs"
                }
            },
            { // Back button
                "eventTarget": ".ebback",
                "eventType": "click",
                "tags": {
                    "componentId": "pse",
                    "componentName": "search equipment",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "back link",
                    "event": "navigation",
                    "eventType": "go back internal navigation click"
                }
            }
        ]
    },
    {
        "target": ".component.expanding-box",
        "codeId": "c05",
        "events": [
            {
                "eventTarget": ".expanding-box-trigger a[href]",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "outbound"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "componentName": "expanding box",
                    "componentId": "c05",
                    "eventType": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "expanding box outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "expanding box internal navigation click"
                        }
                    ],
                    "elementType": "expanding box button",
                    "elementText": "",
                    "titleText": ""
                }
            }
        ]
    },
)